import React from "react";

function SEO({ title, description, keywords, url, image }) {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta name="viewport" content="width=device-width, initial-scale=1" />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <link rel="icon" href="/favicon.ico" />
      <link rel="canonical" href={url} />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Lamar Reinigungsservice",
          "url": url,
          "logo": image,
          "description": description,
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+49 176 45345111",
            "contactType": "customer service",
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Moltkestr. 35",
            "addressLocality": "Karlsruhe",
            "postalCode": "76133",
            "addressCountry": "DE"
          },
          "sameAs": [
            "https://www.facebook.com/people/Lamar-Reinigung-Gartenarbeit/pfbid0KQJVbE379CwfG2XzDsxebeV6Xi9StwAp5AxExpNKd9QuGnKEueXhTDa2imySHy9Wl/",
            "https://www.youtube.com/@lamarreinigung"
          ]
        })}
      </script>
    </>
  );
}

export default SEO;
